import 'react-big-calendar/lib/sass/styles.scss'

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment';
import Help from '../generics/help';
import ModalNew from './ModalNew';

const $ = require('jquery');
require('moment/locale/es.js');
const localizer = momentLocalizer(moment);

var Config = require('../../config');

class Diary extends Component{
	constructor(props){
		super(props);

		this.eventAgenda = this.eventAgenda.bind(this);
		this.onRegister = this.onRegister.bind(this);
		this.newEvent = this.newEvent.bind(this);

		this.state = {
			events:[],
		}
	}

	componentDidUpdate(){
		console.log($('.rbc-agenda-table'))
	}

	componentDidMount() {
		console.log(this.props)

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'pre_offers',{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}

		}).then(response => {
			if(response !== undefined){
				var events = [];
				response.map((res, i)=>{
					var date = moment(res.timestamp_date).format('YYYY-MM-DD');

					events.push({
						id:res.id,
						title:res.donor,
						donation_type:res.donation_type,
						extraction_type:res.extraction_type,
						start:new Date(date+' '+res.timestamp_hour),
						end:new Date(date+' '+res.timestamp_hour),
						status:res.status,
						color:res.status === "" ? '#3174ad' : '#31ad6e',
					});

					this.setState({events:events});
				})
			}
		});
	}	

	componentDidUpdate(){

	}

	onRegister(e){
		console.log( e)
		var id = e.target !== undefined ? e.target.id : e;

		this.props.history.push('/offers/register/'+id);
	}

	eventAgenda(props){
        return <div style={{display:'flex'}}>
	        <div style={{width:'77%'}}>
	        	<em>
	        		{props.event.title+' - '+props.event.extraction_type+' - '+props.event.donation_type}
	        	</em>
	        </div>
	        <div style={{width:'15%'}}>
	        	<em>
	        		{props.event.status}
	        	</em>
	        </div>
	        <div style={{width:'8%'}}>
	        	{props.event.status === "" ?
	        		<button className="btn btn-info" id={props.event.id} onClick={(e)=> this.onRegister(e)}>Registro</button>

	        	:null}
	        </div>
        </div>
    }

    newEvent(e){
    	e.preventDefault();
		this.modal_new.handleShow();
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Agenda
					</h5>
				</div>

				<Help 
					{...this.props}
					menu={"help_donors"} 
					submenu={"help_pre_offers"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-1">
						<button className="btn btn-info" onClick={this.newEvent}>
							Nuevo Evento
						</button>
					</div>
				</div>

				<div className="col-xs-12">
					<div style={{height:`${500}px`}} className="bigCalendar-container">
						<Calendar
							step={30}
							length={1}
						    defaultDate={new Date()}
						    localizer={localizer}
						    events={this.state.events}
						    components={{
			                  	agenda: {
			                  		event: this.eventAgenda
			                   	}
			                }}
			                startAccessor="start"
            				endAccessor="end"
						    onSelectEvent={(event) => this.onRegister(event.id) }
						    views={['month', 'agenda']}
						    messages={{
				              	next: "sig",
				              	previous: "ant",
				              	today: "Hoy",
				              	month: "Mes",
				              	week: "Semana",
				              	day: "Día",
				              	noEventsInRange:'No Existen eventos en este rango de fechas'
				            }}
				            eventPropGetter={event => ({
							    style: {
							      backgroundColor: event.color,
							    },
							})}
							popup
						  />
					</div>
				</div>

				<ModalNew {...this.props} onRef={ref => (this.modal_new = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Diary);